import { ApiService } from "@/api";

export const submitAnswer = (sampleId: string, answer: any) => {
  return ApiService.baseAction(
    `answer/submit/${sampleId}`,
    {
      data: answer,
    },
    "POST"
  );
};
